import { render, staticRenderFns } from "./Buttonvideo.vue?vue&type=template&id=72685f87&scoped=true&"
import script from "./Buttonvideo.vue?vue&type=script&lang=js&"
export * from "./Buttonvideo.vue?vue&type=script&lang=js&"
import style0 from "./Buttonvideo.vue?vue&type=style&index=0&id=72685f87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72685f87",
  null
  
)

export default component.exports